import { required, optional } from 'AppReact/schema';

export default {
    isVisible: required('boolean'),
    ids: optional('array'),
    reason: optional('string'),
    reasonError: optional('string')
}

export const defaultReasonModalState = {
    isVisible: false,
    ids: [],
    reason: '',
    reasonError: ''
}
